module.exports = __webpack_public_path__ + "img/161.6347b61c.jpg";